import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { actions } from '@/store/actions'
import { mutations } from '@/store/mutations'
import { getters } from '@/store/getters'
import Account from '@/api/models/Account'
import Brand from '@/api/models/Brand'
import Campaign from '@/api/models/Campaign'
import Reference from '@/api/models/Reference'
import Settings from '@/api/models/Settings'
import References from '@/api/models/References'
import WarehousesMapping from '@/api/models/WarehousesMapping'
import OrderStatusesDto from '@/api/dto/OrderStatusesDto'
import ReturnStatusesDto from '@/api/dto/ReturnStatusesDto'
import PaymentTypesDto from '@/api/dto/PaymentTypesDto'
import CampaignReferences from '@/api/models/CampaignReferences'
import SettingsMapping from '@/api/models/SettingsMapping'
import CatalogManagementDto from '@/api/dto/CatalogManagementDto'

export interface State {
    loading: boolean;
    brand: Brand;
    accounts: Array<Account>;
    campaigns: Array<Campaign>;
    sites: Array<Reference>;
    currentAccount: number;
    currentCampaign: number;
    settings: Settings;
    references: References;
    campaignReferences: CampaignReferences;
    priceLink: string;
    notificationKey: string;
    orderStatuses: OrderStatusesDto;
    returnOrderStatuses: ReturnStatusesDto;
    paymentTypes: PaymentTypesDto;
    warehouses: Array<WarehousesMapping>;
    costs: Array<SettingsMapping>;
    catalogMapping: CatalogManagementDto;
}

const rootState: State = {
    loading: true,
    brand: {
        key: '',
        name: '',
        docLink: ''
    },
    accounts: [],
    campaigns: [],
    sites: [],
    currentAccount: 0,
    currentCampaign: 0,
    settings: {},
    references: {
        prices: {},
        orderMethods: {},
        orderTypes: {},
        paymentStatuses: {},
        marketPaymentTypes: [],
        systemWarehouses: [],
        systemCosts: [],
        statuses: {},
        externalFields: {},
        loaded: false,
        productIdFields: {}
    },
    campaignReferences: {
        systemPaymentTypes: {},
        loaded: false
    },
    priceLink: '',
    notificationKey: '',
    orderStatuses: {
        statusesFromMarket: [],
        statusesToMarket: []
    },
    returnOrderStatuses: {
        statusesFromMarket: [],
        statusesToMarket: []
    },
    paymentTypes: {
        postpaid: [],
        prepaid: []
    },
    warehouses: [],
    costs: [],
    catalogMapping: {}
}

Vue.use(Vuex)

const store: StoreOptions<State> = {
    state: rootState,
    mutations,
    getters,
    actions
}

const state = new Vuex.Store<State>(store)

export default state
